/* eslint-disable */
import React from 'react';
import { TrendingUp, Users, Shield, Zap, BarChart3, Cpu } from 'lucide-react';

const StrategicObjectives = () => {
  const objectives = [
    {
      icon: <Shield className="objective-icon" />,
      title: "Strengthen Health Security Systems",
      description: "Enhance national capacities to prevent, detect, and respond to public health threats and emergencies at all levels.",
      color: "#3B82F6",
      metrics: ["Early warning systems", "Laboratory capacity", "Emergency coordination"]
    },
    {
      icon: <Zap className="objective-icon" />,
      title: "Develop and Sustain Surge Capacity",
      description: "Build and maintain robust rapid response teams to ensure readiness for effective action during outbreaks and health emergencies.",
      color: "#10B981",
      metrics: ["Response teams", "Training programs", "Equipment stockpiles"]
    },
    {
      icon: <Users className="objective-icon" />,
      title: "Promote One Health Approaches",
      description: "Foster active collaboration across human, animal, and environmental health sectors to address zoonotic and emerging diseases.",
      color: "#8B5CF6",
      metrics: ["Joint surveillance", "Cross-sector training", "Integrated research"]
    },
    {
      icon: <TrendingUp className="objective-icon" />,
      title: "Enhance Multisectoral Coordination",
      description: "Strengthen partnerships with government institutions, communities, and development partners for integrated health security efforts.",
      color: "#F59E0B",
      metrics: ["Partnership networks", "Coordination mechanisms", "Community engagement"]
    },
    {
      icon: <BarChart3 className="objective-icon" />,
      title: "Improve Monitoring, Evaluation, and Research",
      description: "Support evidence-based decision-making through robust operational research, data analysis, and timely performance reporting.",
      color: "#EF4444",
      metrics: ["Data systems", "Research initiatives", "Performance metrics"]
    },
    {
      icon: <Cpu className="objective-icon" />,
      title: "Build Institutional Resilience and Capacity",
      description: "Strengthen workforce skills, infrastructure, and systems to ensure sustainable and effective health security interventions.",
      color: "#06B6D4",
      metrics: ["Workforce development", "Infrastructure upgrades", "System sustainability"]
    }
  ];

  return (
    <section className="objectives-section" id='strategic-objectives'>
      <div className="section-header">
        <div className="section-badge">Our Strategy</div>
        <h2>Strategic Objectives</h2>
        <p className="section-description">
          Six pillars guiding our mission to protect South Sudan from health threats
        </p>
      </div>
      
      <div className="objectives-container">
        <div className="objectives-grid">
          {objectives.map((objective, index) => (
            <div key={index} className="objective-card">
              <div className="objective-header">
                <div 
                  className="objective-icon-container"
                  style={{ backgroundColor: `${objective.color}15`, borderColor: objective.color }}
                >
                  {objective.icon}
                </div>
                <div className="objective-number">0{index + 1}</div>
              </div>
              
              <div className="objective-content">
                <h3>{objective.title}</h3>
                <p>{objective.description}</p>
                
                <div className="objective-metrics">
                  <h4>Key Focus Areas:</h4>
                  <div className="metrics-list">
                    {objective.metrics.map((metric, idx) => (
                      <span key={idx} className="metric-tag" style={{ backgroundColor: `${objective.color}15`, color: objective.color }}>
                        {metric}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              
              <div 
                className="objective-accent"
                style={{ backgroundColor: objective.color }}
              ></div>
            </div>
          ))}
        </div>
      </div>

      <div className="strategy-footer">
        <div className="strategy-note">
          <h4>Aligned with National & International Commitments</h4>
          <p>
            Our strategic objectives are developed in alignment with the National Action Plan for Health Security (NAPHS), 
            International Health Regulations (IHR 2005), and South Sudan's national development goals.
          </p>
        </div>
      </div>
    </section>
  );
};

export default StrategicObjectives;